const fetchTicket = async ticketId => {
    try {
        const response = await fetch("/api/tickets/" + ticketId, { method: "HEAD" });

        return response.status === 200;
    } catch (e) {
        return false;
    }
};

const store = {
    namespaced: true,
    state: {
        data: {},
        fetching: false,
    },
    mutations: {
        SET_FETCHING(state) {
            state.fetching = true;
        },
        UNSET_FETCHING(state) {
            state.fetching = false;
        },
        SET_TICKET(state, payload) {
            state.data = payload;
        },
    },
    actions: {
        checkTicket({ commit }, { ticketId }) {
            commit("SET_FETCHING");

            return new Promise(resolve => {
                const timeout = () =>
                    setTimeout(async () => {
                        const result = await fetchTicket(ticketId);

                        if (result) {
                            commit("UNSET_FETCHING");

                            return resolve();
                        }

                        timeout();
                    }, process.env.TIMEOUT_CHECK_TICKET_EXIST || 5000);

                timeout();
            });
        },
    },
    getters: {
        isEmpty(state) {
            return Object.keys(state.data).length !== 0;
        },
    },
};

export default store;
